export default __webpack_public_path__ + "static/media/puneuniversity.beac59bf.jpg";